'use strict';

/*
  all images get imgix in preview via LSDS apache rewrite in site.include
  production uses a Lambda func, preproduction does NOT use imgix at all
  { w: xxx } is expected, but not required, dpr does nothing without a width
*/

define('lib/imgix',['jquery', 'modernizr', './modernizr.retina'], function ($, modernizr) {
  return function __imgixQueryString(url, opts) {
    var defaultOpts = {
      dpr: modernizr.retina ? 2 : 1,
    };
    var imgixQueryString = $.param($.extend(defaultOpts, opts));
    return url + '?' + imgixQueryString;
  };
});

